import { IM_CTX, IM_MESSAGE } from '@/typings/global';

const CONTEXT_TYPES = ['out', 'in', 'faq-init', 'faq-questions', 'faq-art', 'faq-resolve'];

/** 问题卡片只提取标题，答案由后续的faq-resolve消息提供。 */
const buildQuestionContent = ({ type, message, ctx }: IM_MESSAGE): string => {
    const questions = (Array.isArray(ctx) ? ctx : [])
        .map((item) => item?.title)
        .filter((title) => typeof title === 'string' && title.trim())
        .map((title, index) => `${index + 1}. ${title}`);
    const welcome = type === 'faq-init' && typeof message === 'string' ? message : '';
    const questionContent = questions.join('\n');

    return [welcome, questionContent].filter((content) => content.trim()).join('\n');
};

/** 提取人工初始化需要的对话上下文，保留消息顺序及正文格式。 */
export const buildInitMsgList = (messageList: IM_MESSAGE[]) =>
    messageList
        .filter((item) => CONTEXT_TYPES.indexOf(item.type) !== -1)
        .map((item) => {
            let content = item.server_content || item.message;
            if (item.type === 'faq-resolve') {
                content = (item.ctx as IM_CTX)?.answer;
            } else if (item.type === 'faq-init' || item.type === 'faq-questions') {
                content = buildQuestionContent(item);
            }

            if (typeof content !== 'string' || !content.trim()) {
                return null;
            }

            return {
                [item.type === 'out' ? '用户' : '客服']: content,
                时间: item.time || ''
            };
        })
        .filter((item) => item !== null);

/** 保留服务端时间，为没有时间的本地消息记录产生时间。 */
export const withMessageTime = (message: IM_MESSAGE): IM_MESSAGE => ({
    ...message,
    time: message.time || dayjs().format('YYYY-MM-DD HH:mm:ss')
});
